<template>
  <div :class="app_css_classes">

    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      :class="{
        'hamburger-container': true,
        'has-dark-background': $route.meta.isDark,
      }"
      :style="{
        opacity: scroll_fade,
        visibility: scroll_fade === 0 ? 'hidden' : 'visible',
      }" />

    <aside class="menubar-container" @scroll="onScrollSidebar">
      <Menubar />
    </aside>
    <!--
    <aside class="menubar-container">
      <MenubarFake />
    </aside>
    -->

    <main class="main-container" v-if="$ready_goals">

      <slot />

      <keep-alive :include="cachedViews">
        <router-view :key="key"></router-view>
      </keep-alive>
    </main>
    <main v-else class="main-container">
      Loading...
    </main>

    <aside
      v-if="show_task"
      :class="{
        'task-container': true,
        'task-container--overlay': show_task_as_overlay
      }">
      <TaskDetails :key="key_task" />
    </aside>

    <aside v-if="$ready_commitments">
      <!-- TODO: fullscreen button -->
      <OptimizerInputObserver :enable-debug-mode="debugtool.show" />
    </aside>
  </div>
</template>

<script>
import TaskDetails from '@/components/TaskPage/TaskDetails'
import Hamburger from '@/layouts/Elements/Hamburger'
// import Sessions from "@/components/Sessions/Sessions"
import OptimizerInputObserver from "@/components/OptimizerInputObserver"
import { mapGetters } from 'vuex'
import { mapReady } from '@/api/misc'
// import MenubarFake from './MenubarRC2/MenubarFake'
import Menubar from './MenubarRC2'
import { parseTpl } from '@/generic_api/lib/generic_store/template/utils'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      scroll_position_menubar: 0,
    }
  },
  computed: {
    ...mapReady('goals', 'commitments'),
    ...mapReady('commitments'),
    ...mapGetters("app",[
      "sidebar",
      "debugtool",
    ]),

    cachedViews() {
      return [];
    },

    key() {
      if ( this.$route.meta.cacheKey !== undefined ) {
        let cacheKey = parseTpl( this.$route.meta.cacheKey, this.$route.params );
        console.log('[layout:default] found cacheKey', cacheKey)
        return cacheKey;
      }
      return this.$route.fullPath
    },

    key_task() {
      return this.$route.params[ 'taskId' ];
    },

    app_css_classes() {
      return {
        'app-container':     true,
        'hide-menubar':      !this.sidebar.opened,
        'open-menubar':      this.sidebar.opened,
        'mobile':            this.sidebar.device === 'mobile', // move to app
        'without-animation': this.sidebar.withoutAnimation,
        'show-debug-tool':   this.debugtool.show
      }
    },

    show_task_as_overlay() {
      return this.$route.meta.showTaskAsOverlay;
    },

    show_task() {
      return !!this.$route.meta.showTask;
    },

    scroll_fade() {
      if ( !this.sidebar.opened ) {
        return 1;
      }
      return Math.max(0, 1 - this.scroll_position_menubar / 15);
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    onScrollSidebar(event) {
      this.scroll_position_menubar = event.target.scrollTop;
    },
  },
  components: {
    // MenubarFake,
    Menubar,
    // Sessions,
    OptimizerInputObserver,
    TaskDetails,
    Hamburger,
  }
}
</script>

<style>
#app .app-container {
  width: 100%;
  display: flex;
  flex: 1;
  transition: flex-basis 2500ms ease-in-out;
}

#app .open-menubar .hamburger-container {
  fill: white;
  left: 215px;
}
#app .hamburger-container {
  position: fixed;
  fill: black;
  left: 15px;
  top: 15px;
  z-index: 2;
}
#app .hamburger-container.has-dark-background {
  fill: white;
}

#app .hamburger-spacer {
  padding-left: 50px;
}
#app .open-menubar .hamburger-spacer {
  padding-left: 0;
}

#app .open-menubar .menubar-container {
  width: 245px !important;
  margin-left: 0 !important;
}

#app .menubar-container {
  background-color: #2B2726 !important;
  height: 100vh;
  /*overflow: hidden;*/
  overflow-x: auto;
  order: 1;
  width: 245px !important;
  margin-left: -245px;
  transition: margin-left 0.35s ease;
}

#app .main-container {
  /*position: relative; - does not work*/
  height: 100vh;
  overflow-y: auto;
  order: 2;
  flex: 1;
}

#app .task-container {
  /*margin-top: 50px;*/
  order: 3;
  border-left: 1px solid #DCDFE6;
  /*flex: 0.5 0 0;*/
  flex: 1 0 0;
}
#app .task-container--overlay {
  position: absolute;
  width: 50vw;
  right: 0;
  background: white;
  height: calc(100%);
  /*box-shadow: #0000005e -4px 0px 10px 0px;*/
  z-index: 11; /* fixes bug in Firefox */
}
</style>
